import axios from "axios";
import { authKey } from "../constant/storageKey";
import { getFromLocalStorage } from "./local-storage";
import { loggedOut } from "../service/auth.service";

const API = axios.create({
  baseURL: process.env.REACT_APP_API,
});

API.interceptors.request.use(
  function (config) {
    const authToken = getFromLocalStorage(authKey);
    if (authToken != null) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  function (err) {
    return <div>{err}</div>;
  }
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      loggedOut();
      window.location = "/login";
    }
    return Promise.reject(error);
  }
);

export default API;
